import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'yeshiva-caption-logo',
    templateUrl: './yeshiva-caption-logo.component.html',
    styleUrls: ['./yeshiva-caption-logo.component.scss'],
    standalone: true,
})
export class YeshivaCaptionLogoComponent {
    constructor() {}
    public yeshiva: string = $localize`:@@yeshiva:ישיבה`;
    public whyInternet: string = $localize`:@@WhyInternet:בשביל זה יש אינטרנט`;
}
